import {SystemServerVersionsActionTypes} from "./actionTypes";

export const SystemServerVersionsActionCreators = {
    getSystemServerVersions: () => ({
        type: SystemServerVersionsActionTypes.GET_SYSTEM_SERVER_VERSIONS
    }),

    toggleSystemServerVersionStatus: (systemServerVersionId, active) => ({
        type: SystemServerVersionsActionTypes.TOGGLE_SYSTEM_SERVER_VERSION_STATUS,
        payload: {
            active,
            systemServerVersionId
        }
    }),
};
